<template>
  <div class="search-content">
    <div class="top">
      <!-- 筛选 -->
      <div class="search-item">
        <!-- <div class="search-time">
          <div class="search-input">
            <div class="search-icon iconfont icon-sousuo"></div>
            <input
              class="input"
              type="text"
              autofocus
              v-model="defaultValue"
              placeholder="请输入营期"
              bindinput="bindInput"
              bindconfirm="bindconfirm"
            />
          </div>
          <div class="cancel" @click.stop="cancelSearch">取消</div>
        </div> -->
        <van-search
          class="search-container"
          v-model="value"
          show-action
          placeholder="请输入搜索关键词"
          @input="bindInput"
          @cancel="cancelSearch"
        />
      </div>
    </div>
    <div class="bottom">
      <div class="result-container" v-if="resultList.length">
        <div class="result-list">
          <div
            class="result-item"
            v-for="(item, index) in resultList"
            :key="index"
            @click.stop="bindSelect(index)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <div
        class="history-container"
        v-if="historyList.length && !resultList.length"
      >
        <div class="history-top">
          <div class="history-title">历史记录</div>
          <div
            class="clear iconfont icon-shanchu"
            @click.stop="clearHistory"
          ></div>
        </div>
        <div class="history-list">
          <div
            class="history-item"
            v-for="(item, index) in historyList"
            :key="index"
            @click.stop="clickHistory(index)"
          >
            {{ item }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => {
        ;[]
      }
    }
  },
  data() {
    return {
      defaultValue: '',
      value: '',
      campList: [],
      resultList: [], //搜索后的营期列表
      historyList: [] //历史搜索列表
    }
  },
  watch: {
    data(val) {
      this.updateCampList(val)
    }
  },
  created() {
    this.updateCampList(this.data)
    this.getHistory()
    this.throttle = this.throttleFunc(this.searchResult, 500)
  },
  methods: {
    //取消搜索
    cancelSearch() {
      this.$emit('hidesearch')
    },
    bindCancel() {},
    bindInput(val) {
      this.value = val
      this.throttle(val)
    },
    bindconfirm(e) {
      let val = e.detail.value
      this.value = val
      this.searchResult(val, true)
    },
    //选择哪个营期时
    bindSelect(index) {
      this.saveHistory(this.value)
      this.$emit('confirm', this.resultList[index])
      this.cancelSearch()
    },
    clickHistory(index) {
      let value = this.historyList[index]
      this.value = value
      this.defaultValue = value
      this.throttle(value)
    },
    getHistory() {
      let data = JSON.parse(localStorage.getItem('historySearch'))
      this.historyList = data || []
    },
    //保存历史记录
    saveHistory(str) {
      if (str === '') {
        return
      }
      let maxHistory = 10 //最大历史记录数量
      let res = this.historyList.filter((item) => {
        return item !== str
      })
      if (res.length >= maxHistory) {
        res.slice(0, maxHistory + 1)
      }
      res.unshift(str)
      this.historyList = res
      localStorage.setItem('historySearch', JSON.stringify(this.historyList))
    },
    clearHistory() {
      this.historyList = []
      localStorage.setItem('historySearch', JSON.stringify(this.historyList))
    },
    deleteHistory() {},
    //节流函数
    throttleFunc(callback, delayTime) {
      let timeId = undefined
      let self = this
      return function () {
        if (timeId !== undefined) {
          clearTimeout(timeId)
        }
        timeId = setTimeout(() => {
          callback.apply(self, arguments)
          timeId = undefined
        }, delayTime)
      }
    },
    //搜索结果
    searchResult(val, isConfirm) {
      let res = this.filterCamp(val, this.campList, isConfirm)
      this.resultList = res
    },
    //更新营期列表
    updateCampList(data) {
      if (data && data.length) {
        this.campList = data
      }
    },
    //过滤符合邀请的营期
    filterCamp(keyword, data, isConfirm) {
      let res = []
      if (keyword === '' && !isConfirm) {
        return res
      }
      data.map((item) => {
        if (item.name.includes(keyword)) {
          res.push(item)
        }
      })
      return res
    }
  }
}
</script>
<style lang="scss">
.search-container {
  .van-cell {
    background-color: #f7f7f7;
    border-radius: 15px;
    padding-left: 20px;
  }
}
</style>
<style lang="scss" scoped>
.search-content {
  position: fixed;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 99;
  background-color: #fff;
  display: flex;
  flex-direction: column;
}
.search-container {
  width: 100%;
}
.top {
  background-color: #fff;
  position: sticky;
  width: 100%;
  top: 0;
}
.top .search-item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
}
.top .search-item .search-time {
  width: 100%;
  height: 100%;
  padding: 2.7vw 3.2vw;
  box-sizing: border-box;
  border-radius: 1.7vw;
  display: flex;
  align-items: center;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.top .search-item .search-time .text {
  font-size: 3.5vw;
  color: rgba(0, 0, 0, 0.5);
  margin: 0px 5px;
}
.top .search-item .search-input {
  position: relative;
  flex-shrink: 0;
  flex: 1;
  width: 100%;
  height: 30px;
  display: flex;
  align-items: center;
  font-size: 3.5vw;
  color: #000;
  padding: 0px 5px;
  box-sizing: border-box;
  border-radius: 15px;
  background-color: #f7f7f7;
  border: 1px solid #f1f1f1;
}
.search-input .input {
  text-align: left;
  text-indent: 5px;
  flex: 1;
  flex-shrink: 0;
  overflow: hidden;
}
.search-input .input::placeholder {
  line-height: 30px;
}
.cancel {
  font-family: PingFangSC-Regular;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.5);
  margin-left: 10px;
}
.search-icon {
  color: rgba(0, 0, 0, 0.5);
  margin-right: 5px;
}
.bottom {
  flex-shrink: 0;
  flex: 1;
  overflow: hidden;
}
.result-container {
  background-color: #f7f7f7;
  height: 100%;
  overflow-y: auto;
}
.result-list {
  width: 100%;
  padding: 0px 10px;
  box-sizing: border-box;
  background-color: #fff;
  margin-bottom: 20px;
}
.result-list .result-item {
  height: 40px;
  line-height: 40px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border-bottom: 1px solid #f1f1f1;
}
.history-container {
  padding: 10px 20px;
}
.history-title {
  font-size: 12px;
  color: #666;
}
.history-list {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.history-item {
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0px 10px;
  height: 30px;
  line-height: 30px;
  font-size: 13px;
  color: #666;
  border-radius: 15px;
  box-sizing: border-box;
  border: 1px solid #d1d1d1;
  margin-right: 10px;
  margin-bottom: 10px;
}
.history-top {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  justify-content: space-between;
}
</style>
